import React, { useEffect, useState } from "react";
import { Button, Card } from "antd";
import {
  CheckCircleOutlined,
  CloseCircleOutlined,
  LeftOutlined,
  QuestionCircleOutlined,
} from "@ant-design/icons";
import { useNavigate, useLocation } from "react-router-dom";
import Constant from "../../../global/Constant.ts";
import assessmentService from "../../../services/assessmentService.ts";
import { useDispatch } from "react-redux";
import { setLoading } from "../../../redux/globalSlice.ts";
import { decryptData } from "../../../utils/decryptData.ts";

const AssessmentSummary = () => {
  const { state } = useLocation();

  const [summaryData, setSummaryData] = useState({ answers: [] });
  const [assessmentId, setAssessmentId] = useState(null);
  const [userId, setUserId] = useState(null);
  const dispatch = useDispatch();

  const navigate = useNavigate();

  const parseHintContent = (hint) => {
    if (!hint) return null;

    // Split the hint into parts that are either regular text or URLs in curly braces
    const parts = hint.split(/(\{[^}]+\})/);

    return (
      <span>
        {parts.map((part, index) => {
          if (part.startsWith("{") && part.endsWith("}")) {
            // This is a URL part
            const url = part.slice(1, -1);
            return (
              <a
                key={index}
                href={url}
                target="_blank"
                rel="noopener noreferrer"
                className="vm__read-more-link"
              >
                Read more
              </a>
            );
          } else if (part) {
            // This is regular text - return it directly without wrapping span
            return part;
          }
          return null;
        })}
      </span>
    );
  };

  useEffect(() => {
    if (!state || !state.assessmentId || !state.userId) {
      navigate("/", { replace: true });
    } else {
      setAssessmentId(state.assessmentId);
      setUserId(state.userId);
    }
  }, [state, navigate]);
  /* eslint-disable react-hooks/exhaustive-deps */
  useEffect(() => {
    const fetchSummaryData = async () => {
      try {
        dispatch(setLoading(true));
        const response = await assessmentService.getAssessmentSummaryData(
          Constant.assessmentanswers,
          assessmentId,
          userId
        );
    
        const encryptedData = response?.encryptedData;
    
        if (!encryptedData) {
          setSummaryData({ answers: [] });
          return;
        }
    
        if (!process.env.REACT_APP_ENCRYPTION_KEY) {
          return;
        }
    
    
        const decrypted = await decryptData(
          encryptedData,
          process.env.REACT_APP_ENCRYPTION_KEY
        );
    
        let answers;
        if (Array.isArray(decrypted)) {
          answers = decrypted;
        } else {
            answers = JSON.parse(decrypted);

        }
    
        setSummaryData({ answers });
      } catch (error) {
        console.error("Failed to fetch assessment summary data:", error);
        setSummaryData({ answers: [] });
      } finally {
        dispatch(setLoading(false));
      }
    }; 

    if (assessmentId && userId) {
      fetchSummaryData();
    }
  }, [assessmentId, userId]);

  return (
    <div className="vm__assessment vm__h-100">
      <div className="vm__container vm__h-100 ">
        <div className="vm__d-flex vm__h-100 vm__flex-column vm__gap-3">
          <div className=" vm__overflow-auto">
            <Card className="vm__assessment__card vm__w-100">
              {summaryData.answers && summaryData.answers.length > 0
                ? summaryData.answers.map((answer, index) => (
                    <div
                      key={answer.AssessmentQuestionID}
                      className="vm__d-flex vm__loop-card-summary vm__gap-3 vm__mb-3 vm__pb-3 vm__border-bottom"
                    >
                      <div className="vm__flex-auto vm__summary-count">
                        {index + 1}
                      </div>
                      <div className="vm__flex-fill">
                        <h3>{answer.QuestionText}</h3>
                        <span>
                          <strong>Explanation:</strong>{" "}
                          <span>{parseHintContent(answer.Hint)}</span>
                        </span>
                        <div className="vm__answer-container vm__d-flex vm__gap-3">
                          <div className="vm__flex-auto">
                            <span
                              className={`vm__icon-status ${
                                answer.isTrue
                                  ? "vm__if-correct-answer"
                                  : "vm__if-wrong-answer"
                              }`}
                            >
                              {answer.isTrue ? (
                                <CheckCircleOutlined />
                              ) : (
                                <CloseCircleOutlined />
                              )}
                            </span>
                          </div>
                          <div className="vm__flex-fill">
                            <strong>
                              {answer.isTrue ? "Correct" : "Your"} Answer:
                            </strong>{" "}
                            {answer.UserAnswer}
                          </div>
                        </div>
                        {!answer.isTrue && (
                          <div className="vm__answer-container vm__d-flex vm__gap-3">
                            <div className="vm__flex-auto">
                              <span className="vm__icon-status vm__if-correct-answer">
                                <CheckCircleOutlined />
                              </span>
                            </div>
                            <div className="vm__flex-fill">
                              <strong>Correct Answer:</strong>{" "}
                              {answer.CorrectAnswer}
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  ))
                : null}
            </Card>
          </div>
          <div className="vm__flex-auto">
            <div className="vm__d-inline-block">
              <Button
                type="primary"
                icon={<LeftOutlined />}
                onClick={() => navigate("/knowledgehub", { replace: true })}
              >
                Back to Knowledge Hub
              </Button>
            </div>
            <div className="vm__d-inline-block vm__ms-2">
              <Button
                type="primary"
                icon={<QuestionCircleOutlined />}
                onClick={() => navigate("/assessments", { replace: true })}
              >
                Back to Assesment
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AssessmentSummary;
